import React, { FC } from 'react';
import classNames from 'classnames';

import Icon from '../Icon';

import css from './style.module.scss';

export interface IAvatarProps {
  img?: {
    src: string;
    alt?: string;
  };
  icon?: string;
  border?: 'blackOutline' | null;
  size?: '32';
  className?: string;
  letters?: string;
}

const Avatar: FC<IAvatarProps> = ({ img, icon, border, size, className, letters = 'File' }) => (
  <div
    className={classNames(
      css.avatar,
      { [css[`avatar_border_${border}`]]: border, [css[`avatar_size_${size}`]]: size },
      className,
    )}
  >
    {img ? (
      <img className={css.avatar__img} src={img.src} alt={img.alt} />
    ) : icon ? (
      <div className={css.avatar__icon}>
        <Icon id={icon} />
      </div>
    ) : (
      <div className={css.avatar__letters}>
        <span className={css.avatar__lettersText}>{letters}</span>
      </div>
    )}
  </div>
);

export default Avatar;
